<!-- A generative AI model wrote or edited portions of this file with the supervision of a human developer and careful human review. -->
<svelte:options customElement="map-tool" />

<script>
  import MapTool from "$components/MapTool/MapTool.svelte";
  import { FontsUrban } from "@urbaninstitute/dataviz-components";
  import state_data from "$data/map/state.csv";
  import county_data from "$data/map/county.csv";
  import config_data from "$data/map/config.csv";
  import column_metadata from "$data/column_metadata.csv";
  import source_defaults from "$data/source_defaults.csv";

  // Map geoid → map_id so ToolData's geography key works
  const mapped_state_data = state_data.map((d) => ({ ...d, map_id: d.geoid }));
</script>

<FontsUrban />
<MapTool
  data={mapped_state_data}
  rawData={state_data}
  tableData={county_data}
  configData={/** @type {import("$utils/config").ColumnConfig[]} */ (config_data)}
  metadataData={column_metadata}
  sourceData={source_defaults}
  showStateSummary={true}
/>
